const MAX_AUTHORIZATION_ID_LENGTH = 2048;

export function authorizationIdFromUrl(url) {
  const value = new URL(url).searchParams.get("authorization_id")?.trim() ?? "";
  if (!value || value.length > MAX_AUTHORIZATION_ID_LENGTH) return null;
  return value;
}

export function consentReturnPath(authorizationId) {
  return `/oauth/consent?authorization_id=${encodeURIComponent(authorizationId)}`;
}

export function safeInternalReturnPath(value) {
  if (!value) return null;
  try {
    const parsed = new URL(value, "https://local.invalid");
    if (parsed.origin !== "https://local.invalid") return null;
    if (parsed.pathname !== "/oauth/consent") return null;
    return authorizationIdFromUrl(parsed.href) ? `${parsed.pathname}${parsed.search}` : null;
  } catch {
    return null;
  }
}

export function scopeItems(scope) {
  return typeof scope === "string" ? scope.trim().split(/\s+/).filter(Boolean) : [];
}

export function redirectUrlFromOAuthResult(data) {
  if (!data || typeof data.redirect_url !== "string" || data.redirect_url.trim() === "") {
    throw new Error("Supabase Auth returned no redirect URL.");
  }
  return data.redirect_url;
}
